import React from 'react';
import PriceRangeItem from '@components/catalog/filter-group/components/filter-list/components/PriceRangeItem';
import { useContextSelector } from 'use-context-selector';
import { CatalogContext } from '@context/catalog.context';
import styles from './catalog-price-hotfilter.module.scss';

const CatalogPriceHotfilter = () => {
  const updatePriceRangeFilter = useContextSelector(CatalogContext, (v) => v.updatePriceRangeFilter);

  return (
    <div className={styles.catalogPriceHotfilter}>
      <PriceRangeItem onSubmit={(min, max) => updatePriceRangeFilter(min, max)} />
    </div>
  );
};

export default CatalogPriceHotfilter;
